import { Typography } from '@material-ui/core'
import SitekeyIcon from '@material-ui/icons/VpnKey'

import { getTranslate } from '../../localization'
import useStyles from './styles/SitekeyAddHeader.styles'

const SitekeyAddHeader = () => {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      <SitekeyIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate('Add New Sitekey')}
      </Typography>
    </div>
  )
}
export default SitekeyAddHeader
